import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useFooterStyles } from './FooterSection.styles';

const FooterSection = () => {
    const { classes } = useFooterStyles();

    return (
        <Box component="footer" className={classes.section}>
            <Box className={classes.row}>
                <Typography className={classes.logo}>Nexora</Typography>
                <Box className={classes.links}>
                    <Link to="/services" className={classes.link}>Services</Link>
                    <Link to="/work" className={classes.link}>Work</Link>
                    <Link to="/about" className={classes.link}>About</Link>
                    <Link to="/contact" className={classes.link}>Contact</Link>
                </Box>
            </Box>
            <Box className={classes.legalRow}>
                <Typography variant="caption" color="text.secondary">
                    © {new Date().getFullYear()} Nexora. Concept project.
                </Typography>
                <Box className={classes.links}>
                    <Link to="/imprint" className={classes.link}>Imprint</Link>
                    <Link to="/privacy" className={classes.link}>Privacy</Link>
                </Box>
            </Box>
        </Box>
    );
};

export default FooterSection;
